
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function scopeIsWheel2() {
                    var isWheel = this.FitmentType?.includes('Wheel');
                    return _createElement('div', { 'className': 'custom_add_to_cart' }, !this.out_of_stock && !isWheel ? _createElement('a', {
                        'href': this.url,
                        'data-quantity': '1',
                        'type': 'submit',
                        'data-product_id': this.product_id,
                        'data-product_sku': this.removeHTML(this.sku),
                        'rel': 'nofollow',
                        'className': 'button product_type_variation add_to_cart_button ajax_add_to_cart',
                        'aria-label': 'Add to cart: \u201C' + this.removeHTML(this.name) + '\u201D',
                        'key': '868'
                    }, '\n        ', _translate(`product_add_to_cart`), '\n      ') : null, !this.out_of_stock && isWheel ? _createElement('a', {
                        'href': this.url,
                        'className': 'button',
                        'key': '1274'
                    }, ' View Options ') : null, this.out_of_stock ? _createElement('a', {
                        'href': this.url,
                        'className': 'button product_type_variation add_to_cart_button disabled ajax_add_to_cart',
                        'key': '1381'
                    }, '\n        ', _translate(`product_out_of_stock`), '\n      ') : null);
                }
                function scopeIsPLPProduct3() {
                    var isPLP = !this.productData;
                    var product = this.productData ?? this;
                    return [product.is_autosync_allowed ? _createElement('button', {
                            'className': !isPLP ? 'cm_view-on-vehicle-btn button' : 'button product_type_variation add_to_cart_button ajax_add_to_cart visualizer',
                            'onClick': () => window.Convermax.openAutoSyncDialog(product.autosync_id, product.autosync_mpn, product.FitmentType?.includes('Tire')),
                            'type': 'button',
                            'key': '15971'
                        }, '\n    ', _translate(`view_product_on_vehicle`), '\n  ') : null];
                }
                return _createElement('li', { 'className': 'product' }, _createElement('a', {
                    'href': this.url,
                    'className': 'woocommerce-LoopProduct-link woocommerce-loop-product__link'
                }, _createElement('img', {
                    'className': 'attachment-woocommerce_thumbnail size-woocommerce_thumbnail',
                    'src': this.imageOrDefault(this.image),
                    'alt': this.removeHTML(this.name),
                    'onError': this.onImageError
                }), _createElement('h2', mergeProps({ 'className': 'woocommerce-loop-product__title' }, { dangerouslySetInnerHTML: { __html: typeof this.name === 'undefined' ? '' : this.name } })), _createElement('span', { 'className': 'price' }, _createElement('span', { 'className': 'woocommerce-Price-amount amount' }, this.formatPrice(this.price), this.max_price ? [
                    '\n          - $',
                    this.formatPrice(this.max_price)
                ] : null))), _createElement('div', { 'className': 'woocommerce-loop-product__buttons' }, scopeIsWheel2.apply(this, []), [scopeIsPLPProduct3.apply(this, [])]));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-items elementor-widget-container' }, _createElement('div', { 'className': 'cm_SearchResult' }, _createElement.apply(this, [
        'ul',
        { 'className': 'products elementor-grid columns-4 cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ])));
}
        export const componentNames = []